import { render } from "./AudioRating.vue?vue&type=template&id=a63d921e&ts=true"
import script from "./AudioRating.vue?vue&type=script&lang=ts"
export * from "./AudioRating.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__